<template>
  <div id="app">
    <navbar />
    <section class="section">
      <div class="container">
      <router-view />
      </div>
    </section>
  </div>
</template>

<script>
// import SideMenu from './components/SideMenu'
import Navbar from './components/Navbar'

export default {
  name: 'App',
  components: {
    Navbar
  }
}
</script>
<style>
</style>
